import { Table } from 'react-bootstrap';
import { IAuditLogDetail } from '../../../interfaces/IAudit';
import { CaseAuditRow } from './CaseAuditRow';
import { ICaseAuditLog } from '../../../interfaces/ICase';
import { ToggleIcon } from '../../../shared/ToggleIcon';
import { useState } from 'react';

export default function CaseAuditTable(props: { results: ICaseAuditLog[] }) {
     const [activeKeys, setActiveKeys] = useState<string[]>([]);
    
        const hasRows = (props.results.length ?? 0) > 0;
    
        const atleastOneExpanded = activeKeys.length > 0;
    
        const handleExpandCollapseAll = () => {
            atleastOneExpanded ? handleCollapseAll() : handleExpandAll();
        };
    
        const handleExpandAll = () => {
            setActiveKeys(
                props.results.map((x) => x.guid) ?? []
            );
        };
    
        const handleCollapseAll = () => {
            setActiveKeys([]);
        };
    
    return (
        <Table size="sm">
            <thead>
                <tr>
                    <th style={{ width: 30 }}>
                        <ToggleIcon
                                onClick={handleExpandCollapseAll}
                                isOpen={atleastOneExpanded}
                            />
                    </th>
                    <th>User</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                {props.results?.map((caseAuditLog: ICaseAuditLog) => {
                    return <CaseAuditRow key={caseAuditLog.guid} caseAuditLog={caseAuditLog} activeKeys={activeKeys} />;
                })}
            </tbody>
        </Table>
    );
}
